import { useRoutes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { RegisterPage } from './pages/RegisterPage';
import { UnsubscribePage } from './pages/UnsubscribePage';
import { SubscribedPage } from './pages/SubscribedPage';
import { UnsubscribedPage } from './pages/UnsubscribedPage';
import { ErrorPage } from './pages/ErrorPage';
import { NotFoundPage } from './pages/NotFoundPage';

import { ConfirmSubscriptionPage } from './pages/ConfirmSubscriptionPage';
import { ConfirmUnsubscriptionPage } from './pages/ConfirmUnsubscriptionPage';

export function AppRoutes() {
  const routes = useRoutes([
    { path: '/', element: <HomePage /> },
    { path: '/home', element: <HomePage /> },
    { path: '/register', element: <RegisterPage /> },
    { path: '/unsubscribe', element: <UnsubscribePage /> },
    { path: '/subscribed', element: <SubscribedPage /> },
    { path: '/unsubscribed', element: <UnsubscribedPage /> },
    { path: '/newsletter/subscribe/confirm', element: <ConfirmSubscriptionPage /> },
    { path: '/newsletter/unsubscribe/confirm', element: <ConfirmUnsubscriptionPage /> },
    { path: '/error', element: <ErrorPage /> },
    { path: '*', element: <NotFoundPage /> },
  ]);

  return routes;
}

